"use client"
import Link from "next/link"
import { Button } from "@/components/ui/button"
import MainLayout from "./(main)/layout"

export default function NotFound() {
	return (
		<MainLayout>
			<div className="flex flex-col items-center justify-center px-4 text-center mt-20">
				<div className="max-w-xl w-full backdrop-blur-sm rounded-2xl p-8">
					<div className="text-7xl font-extrabold text-main mb-2">
						404
					</div>
					<h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
						الصفحة غير موجودة
					</h1>
					<p className="text-gray-600 mb-6 leading-relaxed">
						عذرًا، الصفحة التي تبحث عنها غير متاحة أو قد تم نقلها.
					</p>

					<div className="flex flex-col sm:flex-row items-center justify-center gap-3">
						<Link href="/">
							<Button size="lg" className="w-full sm:w-auto">
								العودة إلى الرئيسية
							</Button>
						</Link>
						<Link href="/jobs">
							<Button
								variant="outline"
								size="lg"
								className="w-full sm:w-auto"
							>
								استعراض الوظائف
							</Button>
						</Link>
					</div>
				</div>
			</div>
		</MainLayout>
	)
}
